import { useSelector } from "react-redux";

export function useExtractclientmail() {
  const clientsData = useSelector((state) => state?.loginUserInfo?.loginUserDetails?.client);
  const clients = useSelector((state) => state?.clients?.clients);

  const filteredClients = clientsData
    ?.map((item) => {
      const matchedClient = clients?.find(
        (client) => item?.NameOfClient === client?.clientName
      );
      return matchedClient ? { emailId: matchedClient?.emailId } : null;
    })
    ?.filter(
      (c) => typeof c?.emailId === "string" && c?.emailId.endsWith("@blueplanitcorp.com")
    )
    ?.map((c) => c?.emailId);

  return filteredClients || [];
}
